import {
  core_apimessages_CheckoutAction_Type as CheckoutActionType,
  CoreCheckoutPayPalPaymentInProgress,
} from '../schemas/rql';
import { DataValue } from 'react-apollo';
import { Paths } from './shared/url_helpers';

interface Props {
  data: DataValue<CoreCheckoutPayPalPaymentInProgress.Query, CoreCheckoutPayPalPaymentInProgress.Variables>;
}

export function buildPayPalStartPolling(props: Props) {
  const { data } = props;

  async function startPolling(checkoutId) {
    const promise = new Promise<string>((resolve) => {
      setInterval(async () => {
        const result = await data.refetch({ id: checkoutId, skip: false });

        if (result.data.checkout?.action.type === CheckoutActionType.CHECKOUT_SUCCESS) {
          resolve(result.data.checkout.action.redirectUrl);
        }

        if (isCheckoutFailure(result.data.checkout)) {
          resolve(Paths.cart.expand({ error_checkout_id: checkoutId }));
        }
      }, 500);
    });

    return promise;
  }

  return startPolling;
}

function isCheckoutFailure(checkout) {
  return checkout.action.type === CheckoutActionType.PAYMENT_FAILURE
    || checkout.action.type === CheckoutActionType.CHECKOUT_FAILURE;
}
